import { Link } from "react-router-dom";
import { Chrome } from "lucide-react";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24">
      <div className="pf-soft rounded-3xl p-10 text-center shadow-xl">
        <h2 className="font-cursive text-5xl text-[#4d6a3a]">Acceso admin</h2>
        <p className="mt-3 text-[#3d4a30]">Solo administradores autorizados.</p>
        <button
          onClick={handleLogin}
          className="mt-8 inline-flex items-center gap-3 px-6 py-3 rounded-full bg-white border border-[#a5b58e] hover:bg-[#f4f7ec] shadow font-semibold text-[#3d4a30] hover-lift"
        >
          <Chrome className="w-5 h-5 text-[#4d6a3a]" /> Iniciar sesión con Google
        </button>
        <div className="mt-8 text-sm">
          <Link to="/" className="text-[#5c6b47] link-underline">Volver al inicio</Link>
        </div>
      </div>
    </div>
  );
}
